// ---------------------------------------------------------------------------
// Static brand + section metadata
// ---------------------------------------------------------------------------
export const BRAND = "Styled by Trinya Marieee";
export const TAGLINE = "Where Beauty Becomes Art";

export const SECTIONS = ["hero", "services", "stylists", "gallery", "reviews", "contact"];

// The booking phone number and email live in constants/contact.js, stored
// encoded so spam bots scanning the site's files can't read them.

// ---------------------------------------------------------------------------
// EmailJS config (contact form)
//
// Read from VITE_-prefixed env vars so the same build runs in preview,
// staging, and prod with different EmailJS accounts.
//
// SECURITY NOTE: every value below is intentionally public-safe:
//   - EmailJS public key is documented as safe to expose
//     (https://www.emailjs.com/docs/faq/is-it-okay-to-expose-my-public-key/).
//   - EmailJS service ID and template ID are not secrets on their own; abuse
//     is limited by the allowed-domains setting in the EmailJS dashboard plus
//     the rate limit and spam traps in src/utils/emailClient.js.
//
// DO NOT add an EmailJS *private* key (access token) here. Private keys
// would expose the account to spam abuse and must stay server-side only.
// ---------------------------------------------------------------------------
const env = import.meta.env;

export const EMAILJS_PUBLIC_KEY = env.VITE_EMAILJS_PUBLIC_KEY ?? "";
export const EMAILJS_SERVICE_ID = env.VITE_EMAILJS_SERVICE_ID ?? "";
export const EMAILJS_TEMPLATE_ID = env.VITE_EMAILJS_TEMPLATE_ID ?? "";

export const EMAILJS_IS_CONFIGURED = Boolean(
  EMAILJS_PUBLIC_KEY && EMAILJS_SERVICE_ID && EMAILJS_TEMPLATE_ID,
);

// Visible-in-DevTools warning so a misconfigured deploy fails loud, not silent.
if (typeof window !== "undefined" && env.MODE !== "test" && !EMAILJS_IS_CONFIGURED) {
  // eslint-disable-next-line no-console
  console.warn(
    "[config] VITE_EMAILJS_PUBLIC_KEY / SERVICE_ID / TEMPLATE_ID are not " +
      "all set. The contact form will be disabled until they are.",
  );
}
